export default "__VITE_ASSET__BWy5agFb__"